import React, { createContext, useContext, useState, useEffect } from 'react';
import { initKeycloak, login, logout, isAuthenticated, getToken, getUserInfo, updateToken } from '../services/keycloak';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Initialize Keycloak
    initKeycloak()
      .then((authStatus) => {
        setAuthenticated(authStatus);
        if (authStatus) {
          setUser(getUserInfo());
          // Set up token refresh interval
          const tokenRefreshInterval = setInterval(() => {
            updateToken().catch((error) => {
              console.error('Token refresh failed:', error);
              setAuthenticated(false);
              setUser(null);
            });
          }, 30000); // Refresh every 30 seconds

          return () => clearInterval(tokenRefreshInterval);
        }
      })
      .catch((error) => {
        console.error('Authentication initialization failed:', error);
        setAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleLogin = () => {
    login();
  };

  const handleLogout = () => {
    logout();
    setAuthenticated(false);
    setUser(null);
  };

  const getAccessToken = () => {
    return getToken();
  };

  const value = {
    authenticated,
    loading,
    user,
    login: handleLogin,
    logout: handleLogout,
    getToken: getAccessToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

